<template>
  <div v-if="track" class="py-3">
    <div class="row text-left">
      <div class="col-sm-11 col-lg-8 mx-auto">
        <div class="row">
          <div class="col-sm-6 col-lg-4 font-weight-semibold">
            <p>Track Filename</p>
          </div>

          <div class="col-sm-6 col-lg-8 text-muted">
            <p>
              {{ track.file || "---------" }}
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6 col-lg-4 font-weight-semibold">
            <p>Track Title</p>
          </div>

          <div class="col-sm-6 col-lg-8 text-muted">
            <p>
              {{ track.title || "---------" }}
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6 col-lg-4 font-weight-semibold">
            <p>Track Number</p>
          </div>

          <div class="col-sm-6 col-lg-8 text-muted">
            <p>
              {{ track.track_number || "---------" }}
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6 col-lg-4 font-weight-semibold">
            <p>Track Description</p>
          </div>

          <div class="col-sm-6 col-lg-8 text-muted">
            <p>
              {{ track.comments || "---------" }}
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6 col-lg-4 font-weight-semibold">
            <p>Album Name</p>
          </div>

          <div class="col-sm-6 col-lg-8 text-muted">
            <p>
              {{
                track.album && track.album.name ? track.album.name : "---------"
              }}
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6 col-lg-4 font-weight-semibold">
            <p>Library Name</p>
          </div>

          <div class="col-sm-6 col-lg-8 text-muted">
            <p>
              <span v-if="!track.album || !track.album.library">
                ---------
              </span>
              <span
                v-if="
                  track.album && track.album.library && track.album.library.name
                "
                class="track-library"
              >
                {{ track.album.library.name }}
              </span>
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6 col-lg-4 font-weight-semibold">
            <p>Composers</p>
          </div>

          <div class="col-sm-6 col-lg-8 text-muted">
            <p>
              {{ track.composer || "---------" }}
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6 col-lg-4 font-weight-semibold">
            <p>Genre</p>
          </div>

          <div class="col-sm-6 col-lg-8 text-muted">
            <p>
              <span v-if="!track.genres"> --------- </span>
              <span
                v-if="track.genres"
                class="track-genre"
                v-for="genre in track.genres"
                v-bind:key="genre.id"
                >{{ genre.name }}</span
              >
            </p>
          </div>
        </div>
      </div>
    </div>

    <textarea
      v-model="copiedTrackDetails"
      id="trackDetailsData"
      class="d-none"
    ></textarea>

    <div class="pt-4">
      <a
        href="#"
        class="btn btn-raised btn-lg font-weight-semibold copy-track-details-button"
        v-bind:class="{ 'btn-success': copied, 'btn-info': !copied }"
        data-clipboard-action="copy"
        data-clipboard-target="#trackDetailsData"
      >
        <span v-if="!copied">Copy to clipboard</span>
        <span v-if="copied">Copied</span>
      </a>

      <a
        href="#"
        data-dismiss="modal"
        aria-label="Close"
        class="btn btn-raised btn-danger btn-lg font-weight-semibold"
      >
        Close
      </a>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Clipboard from "clipboard";
import { playerService } from "../player-service";

export default Vue.component("track-details", {
  data: function () {
    return {
      track: null,
      copied: false,
      copiedTrackDetails: null,
      clipboardPlugin: null,
    };
  },

  mounted: function () {
    playerService.$on("open-track-details", (track) => {
      // Update curr track for modal + reset selected project.
      this.track = track;

      // Open the modal.
      window.webpackOpenBsModalWorkaround("#trackDetailsModal");
    });
  },

  watch: {
    track: function (value) {
      this.reset();
    },
  },

  methods: {
    copy: function () {
      this.copied = true;
    },

    reset: function () {
      let ctx = this;
      let libraryName = "";
      let genreNames = "";

      if (
        typeof this.track.album !== "undefined" &&
        this.track.album !== null &&
        typeof this.track.album.library !== "undefined"
      ) {
        libraryName = this.track.album.library.name;
      }

      if (typeof this.track.genres !== "undefined") {
        for (let genre of this.track.genres) {
          if (genreNames != "") {
            genreNames += ", ";
          }

          genreNames += genre.name;
        }
      }

      // Setup the contents of the textarea.
      this.copiedTrackDetails = `Track Filename: ${
        this.track.file || "---------"
      }\nTrack Title: ${this.track.title || "---------"}\nTrack Number: ${
        this.track.track_number || "---------"
      }\nAlbum Name: ${
        this.track.album && this.track.album.name
          ? this.track.album.name
          : "---------"
      }\nLibrary Name: ${
        libraryName == "" ? "---------" : libraryName
      }\nComposers: ${this.track.composer || "---------"}`;

      if (this.clipboardPlugin) {
        this.clipboardPlugin.destroy();
      }

      this.clipboardPlugin = new Clipboard(".copy-track-details-button", {
        container: document.getElementById("trackDetailsModal"),
        text: function (trigger) {
          return ctx.copiedTrackDetails;
        },
      });

      this.copied = false;

      this.clipboardPlugin.on("success", function (e) {
        ctx.copied = true;

        e.clearSelection();
      });
    },
  },
});
</script>
